import "./App.css";
import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ProtectedRoute from "./Components/HOC/ProtectedRoute";
import FallbackUi from "./Components/Fallback/FallbackUi";
import { useNetworkCheck } from "./Components/Hooks/useNetworkCheck";
import NetworkLoss from "./Pages/Network-loss/NetworkLoss";
// import Login from "./Pages/Auth/Login";

const Login = lazy(() => import("./Pages/Auth/Login"));
const Myaccount = lazy(() => import("./Pages/Account/Myaccount"));
const Calendar = lazy(() => import("./Pages/Calendar/Calendar"));
// const Event = lazy(() => import ("./Pages/Events/Event"))
const EventOfDay = lazy(() => import("./Pages/Events/EventOfDay"));

function App() {
  // const { isOnline, handleRetry } = useOnlineStatus();
  const { isOnline } = useNetworkCheck();

  if (!isOnline) {
    return <NetworkLoss />
  }
  return (
    <>
      <ToastContainer />
      <Routes>
        <Route
          path="/"
          element={
            <Suspense fallback={<FallbackUi />}>
              <Login />
            </Suspense>
          }
        />
        <Route
          path="/:encodedEmail"
          element={
            <Suspense fallback={<FallbackUi />}>
              <Login />
            </Suspense>
          }
        />
        <Route
          path="/Myaccount"
          element={
            <Suspense fallback={<FallbackUi />}>
              <ProtectedRoute>
                <Myaccount />
              </ProtectedRoute>
            </Suspense>
          }
        />
        <Route
          path="/Calendar"
          element={
            <Suspense fallback={<FallbackUi />}>
              <ProtectedRoute>
                <Calendar />
              </ProtectedRoute>
            </Suspense>
          }
        />

        {/* <Route
          path="/event"
          element={
            <Suspense fallback={<FallbackUi />} >
            <ProtectedRoute>
              <Event />
            </ProtectedRoute>
            </Suspense>
          }
        /> */}
        <Route
          path="/allevents"
          element={
            <Suspense fallback={<FallbackUi />}>
              <ProtectedRoute>
                <EventOfDay />
              </ProtectedRoute>
            </Suspense>
          }
        />
        {/* <Route path="/test" element={<FallbackUi />} /> */}
      </Routes>
    </>
  );
}

export default App;
